
<div class="cmp-panel">
  <div class="feedback">
    <div class="status" *ngIf="loading">Loading differences…</div>
    <div class="status error" *ngIf="error">{{ error }}</div>
    <div class="status" *ngIf="hasNoDifferences && !loading && !error">No discrepancies were returned by the backend.</div>
  </div>

  <div style="display: flex; gap: 10px; justify-content: space-between; align-items: center;" *ngIf="hostSummaries.length">
    <header class="cmp-header">
      <p>The table below lists every discrepancy surfaced by the gold-source backend view for each device and ASA group.</p>
    </header>
    <div style="display: flex; flex-direction: column; gap: 6px; align-items: flex-end;">
      <div style="display: flex; gap: 10px;">
        <button type="button" class="actions" (click)="copyAllDifferences()" title="Copies only expanded devices">Copy Expanded</button>
        <button type="button" class="actions" (click)="exportAllDifferences()" title="Exports only expanded devices">Export Expanded CSV</button>
      </div>
      <div class="inline-status muted">Only expanded devices are included in Copy/Export.</div>
    </div>
  </div>

  <div class="table-wrapper" *ngIf="hostSummaries.length">
    <table class="host-table">
      <thead>
        <tr>
          <th>Hostname</th>
          <th>Total Differences</th>
          <th>Overview</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let host of hostSummaries; trackBy: trackByHost">
          <tr class="host-row">
            <td class="host-cell td">
              <button
                type="button"
                class="expand-btn"
                [attr.aria-expanded]="host.expanded"
                (click)="toggleHost(host)">
                <span>{{ host.expanded ? '−' : '+' }}</span>
              </button>
              <div class="host-info">
                <div class="host-title">{{ host.hostname }}</div>
              </div>

              <div class="host-actions" *ngIf="host.expanded">
                <button
                  type="button"
                  class="actions"
                  (click)="copyHostDetails(host)"
                  [disabled]="!canCopyHostDetails(host)">
                  Copy Details
                </button>
              </div>
            </td>
            <td class="td">{{ host.totalDifferences }}</td>
            <td class="severity-cell td">
              <ng-container *ngIf="getSeverityBadges(host) as badges">
                <div class="badge-row" *ngIf="badges.length">
                  <span
                    class="severity-badge"
                    *ngFor="let badge of badges"
                    [ngClass]="badge.className">
                    {{ badge.label }} • {{ badge.count }}
                  </span>
                </div>
                <div class="inline-status muted" *ngIf="!badges.length && !host.loadingDetails"> Click the plus icon to expand and view details.</div>
                <div class="inline-status" *ngIf="!badges.length && host.loadingDetails">Loading summary…</div>
              </ng-container>
            </td>
          </tr>
          <tr class="detail-row" *ngIf="host.expanded">
            <td colspan="4">
              <div class="detail-panel">
                <div class="status" *ngIf="host.loadingDetails">Loading drift details…</div>
                <div class="status error" *ngIf="host.detailsError">{{ host.detailsError }}</div>

                <div class="detail-content" *ngIf="host.details?.length">
                  <div class="inner detail-table">
                    <table>
                      <thead>
                        <tr class="member-row">
                          <th class="group-col">Group</th>
                          <th>Diff Type</th>
                          <th>Device / ASA Value</th>
                          <th>Gold Source Value</th>
                        </tr>
                      </thead>
                      <tbody *ngFor="let detail of host.details; trackBy: trackByDetail">
                        <tr class="member-row">
                          <td class="td group-col">{{ detail.groupName ?? detail.label }}</td>
                          <td class="td">{{ getDiffType(detail) }}</td>
                          <td class="td">{{ getDiffType(detail) == 'EXTRA_IN_DEVICE' ? detail.groupName : formatValue(getCurrentValue(detail))  }}</td>
                          <td class="td">{{ formatValue(getExpectedValue(detail)) }}</td>
                        </tr>
                        <!-- Auto-populated member rows -->
                        <ng-container *ngIf="$any(detail).membersState as ms">
                          <ng-container *ngIf="ms.loading" class="status">Loading member differences…</ng-container>
                          <ng-container *ngIf="ms.error" class="status error">{{ ms.error }}</ng-container>
                          <tr *ngFor="let member of ms.members; trackBy: trackByMember" class="member-row">
                            <td class="td"></td>
                            <td class="td">{{ getMemberDiffType(member) }}</td>
                            <ng-container *ngIf="getMemberDiffType(member) == 'MISSING_IN_DEVICE'">
                              <td class="td">—</td>
                              <td class="td">{{ getMemberName(member) }}</td>
                            </ng-container>
                            <ng-container *ngIf="getMemberDiffType(member) == 'EXTRA_IN_DEVICE'">
                              <td class="td">{{ getMemberName(member) }}</td>
                              <td class="td">—</td>
                            </ng-container>
                            <ng-container *ngIf="getMemberDiffType(member) == 'HASH_MISMATCH'">
                              <td class="td">{{ getMemberName(member) }}</td>
                              <td class="td">Different value</td>
                            </ng-container>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>